import axios from '@axios'
import $http from '@/libs/http'

export default {
  namespaced: true,
  state: {
    sourceOptions: null,
  },
  getters: {},
  mutations: {},
  actions: {
    fetchSourceList(ctx) {
      return new Promise((resolve, reject) => {
        $http
          .get('/api/v1/user/source_list')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUserList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        $http
          .post('/api/v1/user/list', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTransactionList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        $http
          .post('/api/v2/admin/user/transaction_list', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
